import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from '@/components/ErrorBoundary';
import { applyTheme } from '@/config/site.config';
import { LocaleProvider } from '@/i18n';
import './styles/index.css';

// Apply the configured brand colours, fonts, and theme mode before first paint.
applyTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ErrorBoundary>
            {/* Optional i18n scaffold (`src/i18n/`) — see `siteConfig.i18n`. Safe to
          always mount: with `i18n.enabled: false` (default) it just serves the
          `en` dictionary and no `LanguageSwitcher` is rendered. */}
            <LocaleProvider>
                <App />
            </LocaleProvider>
        </ErrorBoundary>
    </React.StrictMode>,
);
